import './modal.scss';

import Modal, {
  type ModalProps,
  type ModalSemanticClassNames
} from 'antd/lib/modal';
import React from 'react';

interface ChildrenArguments {
  classes: {
    actions: string;
    form: string;
  };
}

interface IProps extends Omit<ModalProps, 'children' | 'classNames'> {
  children?:
    | ((props: ChildrenArguments) => React.ReactElement)
    | React.ReactNode;
  onClose: () => void;
  classNames?: ModalSemanticClassNames;
}

const childrenClassNames: ChildrenArguments['classes'] = {
  actions: 'app-modal__actions',
  form: 'app-modal__form'
};

const getClassName = (classNames: (string | undefined)[]) => {
  return classNames.filter(Boolean).join(' ');
};

const CustomModal: React.FC<IProps> = ({
  centered = true,
  width = 484,
  children,
  ...props
}) => {
  return (
    <Modal
      {...props}
      centered={centered}
      mask={
        typeof props.mask === 'object'
          ? {
              closable: true,
              ...(props.mask ?? {})
            }
          : props.mask
      }
      width={width}
      classNames={{
        ...props.classNames,
        header: getClassName(['app-modal__header', props.classNames?.header]),
        body: getClassName(['app-modal__body', props.classNames?.body])
      }}
      className={`app-modal ${props.className ? props.className : ''}`}
      onCancel={props.onClose}
      footer={null}
    >
      {typeof children === 'function'
        ? children?.({ classes: childrenClassNames })
        : children}
    </Modal>
  );
};

export default CustomModal;
